import { Formik, FormikHelpers, Form } from "formik";
import moment from "moment";
import { Modal } from "@mui/material";
import { AddTravellerFormComponent } from "./AddTravellerFormComponent";
import { ICountryData, ISetCustomerData } from "@interfaces";
import styled from "styled-components";
import { StyledButton } from "../StyledComponents";
import _ from "lodash";
import { createNewRedeemer, fetchRedeemer, useAppDispatch } from "@redux";
import { addQuoteCustomersAndReload } from "src/Redux/Slices/quotes";

interface CreateNewModalProps {
    isOpen: boolean;
    onClose: () => void;
    countriesData: ICountryData[];
    isQuotesPage: boolean;
    quoteId?: string;
}

export const AddTravellerModal = ({
    isOpen,
    onClose,
    countriesData,
    isQuotesPage,
    quoteId,
}: CreateNewModalProps) => {
    const dispatch = useAppDispatch();

    const initialValues: ISetCustomerData = {
        title: "Mr",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        postalCode: "",
        countryCode: "",
        dateOfBirth: moment().format("YYYY-MM-DD"),
        customerIndex: 0,
    };

    const handleSubmit = async (
        values: ISetCustomerData,
        { setSubmitting, validateForm }: FormikHelpers<ISetCustomerData>,
    ) => {
        try {
            const validationResult = await validateForm();
            if (!_.isEmpty(validationResult)) {
                return;
            }
            setSubmitting(true);
            const formattedValues = {
                ...values,
                title: "Mr",
                dateOfBirth: moment(values.dateOfBirth).format("DD-MMM-YYYY"),
            };
            if (!isQuotesPage) {
                await dispatch(createNewRedeemer(formattedValues)).unwrap();
                await dispatch(fetchRedeemer());
            } else {
                await dispatch(
                    addQuoteCustomersAndReload({
                        quoteId: Number(quoteId),
                        customers: formattedValues,
                    }),
                );
            }
            onClose();
        } catch (error) {
            console.error("Submission error:", error);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                overflow: "auto",
                padding: "16px",
            }}
        >
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({
                    values,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    isSubmitting,
                    isValid,
                }) => (
                    <StyledForm>
                        <Header>
                            <p className="heading">Additional Traveller</p>
                        </Header>
                        <AddTravellerFormComponent
                            values={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            handleSubmit={handleSubmit}
                            dateValue={moment(values.dateOfBirth).toDate()}
                            countriesData={countriesData}
                            handleChangeDate={(date) =>
                                setFieldValue(
                                    "dateOfBirth",
                                    date ? moment(date).format("YYYY-MM-DD") : "",
                                )
                            }
                            isShowErrorDate={false}
                        />
                        <StyledButton
                            className="saveButton"
                            color={["#436CB2 0%", "#28B7C3 100%"]}
                            $borderRadius="4px"
                            type="submit"
                            disabled={!isValid || isSubmitting}
                        >
                            {isSubmitting ? "Saving ..." : "Save"}
                        </StyledButton>
                    </StyledForm>
                )}
            </Formik>
        </Modal>
    );
};

const StyledForm = styled(Form)`
    padding: 30px 16px;
    background-color: #fff;
    border-radius: 8px;
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    .heading {
        font-size: 28px;
        font-weight: 700;
    }
`;
